// Styles
import * as S from './styles';

const Separator = () => {
  return <S.Separator />;
};

export default Separator;
